import { Form, Formik, FormikHelpers } from "formik";
import { Button } from "@material-ui/core";
import React from "react";
import * as Yup from 'yup';
import { SubscriptionReportRequest } from "../../../models/Report";
import { createSubmitHandler } from "../../form/helpers/formSubmit";
import { SalesChannelPicker } from "../../form/pickers/SalesChannelPicker";
import { ResellerPicker } from "../../form/pickers/ResellerPicker";
import { ProductPicker } from "../../form/pickers/ProductPicker";
import YesNoPicker from '../../form/pickers/YesNoPicker';
import { DateInput } from '../../form/inputs/DateInput';
import SubscriptionStatusPicker from '../../form/pickers/SubscriptionStatusPicker'

interface Props<T> {
    initialValues: T;
    validationSchema: any;
    onSubmit: (values: T, actions: FormikHelpers<T>) => void;
}

function SearchForm<T>({ initialValues, validationSchema, onSubmit }: Props<T>) {
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ resetForm, handleSubmit }) => {
                return (
                    <Form onSubmit={handleSubmit}>
                        <SalesChannelPicker name='salesChannelId' label='Sales Channel' allowEmpty={true} emptyValueDescription='-- ALL --' emptyValue='' />
                        <ResellerPicker name='resellerId' label='Reseller' allowEmpty={true} emptyValueDescription='-- ALL --' emptyValue='' />
                        <ProductPicker name='productId' label='Product' allowEmpty={true} emptyValueDescription='-- All --' emptyValue='' />
                        <SubscriptionStatusPicker name='subscriptionStatus' label='Status' allowEmpty={true} emptyValueDescription='-- ALL --' emptyValue='' />
                        <YesNoPicker name='renewed' label='Renewed' allowEmpty={true} emptyValueDescription='-- ALL --' emptyValue='' />
                        <DateInput name='dateFrom' label='Date From' maxDate={new Date()} />
                        <DateInput name='dateTo' label='Date To' maxDate={new Date()} />
                        <Button type='submit' variant='contained' color='primary' style={{ margin: '14px' }}>Search</Button>
                        <Button type='submit' variant='contained' color='secondary' style={{ margin: '14px' }} onClick={() => { resetForm(); }}>Clear</Button>
                    </Form>
                );
            }}
        </Formik>
    )
}

export function SubscriptionSearchForm(props: { initValues: SubscriptionReportRequest, onSearch: (results: SubscriptionReportRequest) => void }) {
    const { initValues, onSearch } = props;
    

    const validationSchema = Yup.object().shape({
        salesChannelId: Yup.string()
            .nullable(),

        dateFrom: Yup.date()
            .required("Must enter from date"),

        dateTo: Yup.date()
            .nullable()
            .default(null)
            .when("dateFrom", (dateFrom: Date, Yup: any) => dateFrom && Yup.min(dateFrom, "Date To cannot be before date from"))
    });

    const onSubmit =
        createSubmitHandler(
            (body: SubscriptionReportRequest) => Promise.resolve(body),
            onSearch,
            console.error
    );

    return (
        <SearchForm initialValues={initValues} validationSchema={validationSchema} onSubmit={onSubmit} />
    );
}
